import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../AppStateProvider';

import { companyApi } from './api';
import companyQueryKey from './companyQueryKey';

export const useCompanyEcommerceReportQuery = (domain: string) => {
  const { isOpen } = useAppState();

  return useQuery({
    queryKey: companyQueryKey.ecommerceReportStatus(domain),
    queryFn: ({ signal }) => companyApi.getEcommerceReportStatus(domain, signal),
    enabled: isOpen && !!domain,
  });
};
